/**
 * Created by rastwe on 3/14/2017.
 */

import {normalize} from '../util/utils';
import {modalLevels} from '../util/uiconstants';
import {emptyAuditPlanRelations} from '../util/Ares/auditPlanSummaryState';

/**
 * This file represents the initial state in the Redux store.
 * It's used to provide default values in the reducers, in cases
 * where the store doesn't yet have a value, and there are no
 * action matches in the reducer, so that the return value of
 * the reducer function will never be undefined.
 * Use this file to help give you an idea what the overall
 * picture of the Redux store looks like.
 */

const normalizedValue = normalize();

export default {
	account: {},
	// relations and byBodyId are written only by the audit plan summary bodies (356, 357).
	accounts: {...normalizedValue, relations: {...emptyAuditPlanRelations}, byBodyId: {}},
	accountMetrics: {},
	scotsAndRisksAccountList: [],
	accountAssertions: [],
	accountDetails: {},
	accountTrialBalanceMappings: {},
	activeAnnotation: null,
	annotations: {...normalizedValue},
	appVersion: false,
	aresFormHeaders: {
		headers: {
			...normalizedValue
		},
		sections: {
			...normalizedValue
		}
	},
	aresFormDataByBodyTypeId: {},
	aresMyRiskFactorDescriptions: {
		riskFactors: {
			normalizedValue,
			byId: {},
			allIds: []
		},
		descriptions: {
			...normalizedValue
		}
	},
	aresLinkedDocuments: {},
	aresTaskDocuments: {
		documents: {
			...normalizedValue
		}
	},
	aresTaskRelatedDocuments: [],
	aresTaskDetails: {},
	aresTaskList: {
		...normalizedValue
	},
	assertions: {},
	assessRiskSummary: {},
	aiChatBotIntegrationParameters: {},
	formDetailsOpenedInDrawer: {},

	bodiesSpecial: {
		metadata: {},
		accounts: {
			...normalizedValue
		},
		scots: {
			...normalizedValue
		},
		controls: {
			...normalizedValue
		},
		risks: {
			...normalizedValue
		},
		itProcesses: {
			...normalizedValue
		},
		itRisks: {
			...normalizedValue
		},
		itControls: {
			...normalizedValue
		},
		wcgws: {
			...normalizedValue
		},
		itsoApplications: {
			...normalizedValue
		},
		itApplications: {
			...normalizedValue
		},
		crasummaryAccounts: {
			...normalizedValue
		},
		listingEntities: {
			...normalizedValue
		},
		groupComponents: {
			data: null,
			parameters: {
				pages: null,
				totalEntityCount: null
			}
		},
		orphanedRisks: []
	},
	buildTasks: {},
	bulkRelate: {uploadDocumentIds: [], uploadDocuments: []},

	captureAnnotation: {
		imagesets: {}
	},
	clearRightSideSnapshotView: {},
	configurations: {},
	contentUpdates: [],
	controlAttributes: {},
	controlsDetails: {},
	controls: {},
	controlMetrics: {},
	manageControls: {},
	countries: [],
	countryStatus: {},
	currentAccountSEM: {},
	customFilters: {},
	craAccountValidationCount: 0,

	docHelperDocuments: {},
	documentId: null,
	documents: {
		byId: {},
		allIds: []
	},
	documentExtensions: [],
	duplicateDocuments: [],
	documentsLastModifiedInformation: [],
	documentTypes: {...normalizedValue},
	deficiencies: {},
	manageDeficiencies: {},
	deficiency: {},
	deficiencymetrics: {},
	deficiencyClassTypes: [],
	documentSettingConfiguration: {},

	errors: {},
	engagement: {},
	engagementId: null,
	engagementProfiles: [],
	engagementComments: {
		config: {},
		commentStatuses: {},
		filters: undefined,
		selectedCommentGuid: undefined,
		modalConfig: undefined
	},
	engagementHelixProjects: [],
	engagementHelixProjectSummary: {
		connectionsCount: 0,
		trialBalancesCount: 0
	},
	engagementMetaData: null,
	engagementUsersWithRoles: null,
	engagementUserForIndependence: {},
	entityDocuments: {...normalizedValue},
	engagementTeamMembers: [],
	estimates: {...normalizedValue},
	entityForms: [],
	entityLayers: {},

	filterData: {},
	filter: {
		isLoaded: false
	},
	financialStatement: {...normalizedValue},
	form: {},
	formBodies: {...normalizedValue},
	formBodyRelatedDocuments: [],
	formProfileData: {},
	formBodyDisplayData: {},
	formBodyDisplayDataForUpdating: {},
	formBodyDisplayDataNoStoreUpdate: {},
	formProfileUpdateData: {},
	formBodyData: [],
	formOverwriteData: {},
	formUsers: {},
	formActions: {
		documents: {...normalizedValue},
		selectedActions: {...normalizedValue},
		availableActions: [],
		risks: {...normalizedValue},
		relatedDocuments: [],
		summaryResponses: {...normalizedValue},
		isLoaded: false
	},
	formFilteredActions: {
		documents: {...normalizedValue},
		selectedActions: {...normalizedValue},
		availableActions: [],
		risks: [],
		summaryResponses: {...normalizedValue}
	},
	fourFortyGlDocuments: {},

	flowChart: {},
	flowCharts: {},
	flowchartStep: {},
	goToSource: {},
	groupAudit: {
		accounts: {
			data: null,
			parameters: {
				pages: null,
				page: 1,
				totalEntityCount: null,
				pageSize: 20,
				searchString: ''
			}
		},
		assignedScopes: null,
		components: {
			data: null,
			parameters: {
				pages: null,
				totalEntityCount: null
			}
		},
		componentsV2: {
			data: null,
			parameters: {
				pages: null,
				totalEntityCount: null
			}
		},
		referenceOnlyComponents: {
			data: null,
			page: null,
			pages: null,
			totalEntityCount: null
		},
		groupSnapshots: [],
		scopes: null,
		sections: null,
		snapshots: null,
		groupAuditDocumentUploadOn: {}
	},

	hasBodyIdFilter: false,
	helixAccountsMappingStatus: null,
	helixProjectFilterMetadata: {},
	helixProjects: {},
	helixSnapshot: {},

	independenceActionEngagementUser: {},
	independenceIndividualDocumentId: {},
	internalUser: {},
	internalUsers: {},
	isADCModalOpen: false,
	isAresView: false,
	isCompareResponsesView: false,
	isDrawerMode: false,
	isGuidedWorkFlowV2: false,
	isLoading: false,
	isMediaPlaying: false,
	isModalOpen: false,
	isStandaloneView: false,
	isTrackChangesView: false,
	isValidUserWithProjectAvailable: {},
	itapplication: {
		details: {},
		scots: {...normalizedValue},
		controls: {...normalizedValue}
	},
	itapplicationData: {},
	itAppSODetails: {},
	itcontrolDetails: {},
	itControls: {},
	knowledgeTechnologies: {},
	itPlanning: {
		formActions: null,
		itApplicationMetrics: null,
		itApplicationsForDropdownFilter: null,
		itAttributes: null,
		itApplicationsCatalog: null,
		manageITAppModals: null,
		relatedControlsGraphic: null,
		relatedITApps: null,
		relatedITProcesses: null,
		relatedITProcessesFormActions: null,
		riskFactors: null,
		technologies: null,
		technologyDetails: null,
		technologyDetailsFormActions: null,
		technologyRisks: null,
		uncategorizedCount: null
	},

	itprocess: {},
	itrisk: {},

	navigationFilter: null,
	modalLevel: modalLevels.defaultLevel,

	journalSource: {
		byId: {},
		allIds: []
	},
	knowledgeForms: {
		byId: {},
		allIds: []
	},
	languages: [],
	limitedRiskDocuments: {},

	manageObjects: {},
	manageAccount: {},
	manageAccounts: {...normalizedValue},
	markCompleteTasks: {
		tasks: {...normalizedValue},
		documents: {...normalizedValue}
	},
	materiality: {
		byId: {},
		allIds: []
	},
	misstatementDetails: {activeMisstatement: {}},
	misstatements: {},
	multiEntity: {},

	navigationPanel: {},
	newRisk: {},

	offlinePrep: {},
	ovsProject: {isProjectAssociated: {}, isOtherProjectAssociated: {}, projects: []},
	paansUserData: {},
	pspIndexes: [],

	quickLink: [],

	rbacRoles: [],
	relatedDocuments: {},
	relateItRisks: [],
	deficiencyItRisks: [],
	relatedObjects: [],
	relateRisks: {},
	relateTask: {...normalizedValue},
	risk: {},
	riskFactors: {},
	risks: {},
	riskMetrics: {},
	riskTypes: {},
	modalRisks: {},
	allEngagementRisks: {},
	rnhNoteDetail: {annotations: null, notesModalOpen: false, documentIds: {}},
	roles: [],
	responsiveTasks: {},
	leftPanelValidationFilterValue: null,

	sampleList: {
		...normalizedValue
	},
	sampleItems: {
		...normalizedValue
	},
	sampleItemDocuments: {
		evidence: {},
		temporary: {},
		external: {}
	},
	sampleReferences: {sampleReferences: []},
	scot: {},
	scots: [],
	scotsDetails: {},
	scotMetrics: {},
	signOffs: {
		...normalizedValue
	},
	sectionRelatedObjects: [],
	snapshots: [],
	snapshotDetails: {},
	craSnapshotDetails: [],
	itEnvironmentSnapshotDetails: [],
	snapshotCompareDetails: {},
	showHideRightSideSnapshotView: {},
	showHideLeftSideSnapshotView: {},
	stEntities: {...normalizedValue},
	stEntityId: {},
	submitProfileDetails: {},

	tagItems: {
		tags: {...normalizedValue},
		tagGroups: {...normalizedValue}
	},
	taskList: {},
	taskRelateUnrelate: {},
	timePhases: [],
	trialBalances: {...normalizedValue},
	trialBalance: {...normalizedValue},
	leadsheet: {
		tbData: {ids: [], entities: {}},
		fsData: {ids: [], entities: {}},
		accountSubClassData: {ids: [], entities: {}},
		glAccountData: {ids: [], entities: {}},
		referenceData: {ids: [], entities: {}},
		tickmarkData: {ids: [], entities: {}}
	},
	trialBalancesMetrics: {...normalizedValue},
	toasterDetails: {},
	topHeader: {},
	theme: 'light',

	uploadDocuments: {},
	userData: null,
	userPreferences: {isPreferencesLoaded: false},
	userPresence: {},

	validationdetails: {},
	validations: {},
	auditPlanSummaryValidations: [],

	wcgw: {},
	wcgwRelatedRisks: {},
	wcgws: [],
	wcgwTasks: {},
	withoutapprovalvalidations: {},
	workspaceEngagements: null,
	workspaceMetaData: {},
	engagementTags: {
		...normalizedValue,
		page: 1,
		pages: 0,
		totalEntityCount: 0
	},
	engagementTag: {}
};
